import { descriptData } from "../hooks/auth";

const ADMIN_BASE_URL = "https://job-seeker-cmj.clovermandalay.org/api/v1/admin";
const PUBLIC_BASE_URL = "https://job-seeker-cmj.clovermandalay.org/api/v1";
const IMG_BASE_URL = "https://job-seeker-cmj.clovermandalay.org";
const secretKey = "7D97449D989FA7664494C74F827BE";
const authName = 'jobseekingbyclovermandalay';

const HEADERS = async (): Promise<Record<string, string>> => {
    try {
        const data = await descriptData();
        const token = await JSON.parse(data).token;

        const headers = {
            'Content-Type': 'application/json',
            ...(token && { Authorization: `Bearer ${token}` }),
        };
       
        return headers;
    } catch (error) {
        return {
            'Content-Type': 'application/json',
        };
    }
};

export { authName, ADMIN_BASE_URL, PUBLIC_BASE_URL, IMG_BASE_URL, HEADERS, secretKey };
